var map = {
	"./ISSF_25_meter_precision_and_50_meter_pistol_target.jpg": 7403,
	"./ISSF_air_pistol_target_image.jpg": 7037,
	"./ISSF_air_rifle_target_image.jpg": 1914,
	"./help/help_target1.jpg": 6171,
	"./help/help_target2.JPG": 1875,
	"./help/help_target3.jpeg": 1470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;